export const getStartOfDay = (date) => {
  const end = new Date(date);
  end.setHours(0, 0, 0, 0);
  return end;
};

export const getEndOfDay = (date) => {
  const end = new Date(date);
  end.setHours(23, 59, 59, 999);
  return end;
};

export const stringToStartLocalDate = (value) => {
  return new Date(`${value}T00:00:00.000-03:00`);
};

export const stringToEndLocalDate = (value) => {
  return new Date(`${value}T23:59:59.999-03:00`);
};

export const formatarDataParaBR = (date) => {
  if (!(date instanceof Date)) return null;

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};
